// src/config/routeConfig.js

import HomeDashboard from '../containers/Dashboard/HomeDashboard';
import QualityDashboard from '../containers/Dashboard/QualityDashboard/QualityDashboard';
import Reports from '../containers/Reports';
import AppUserReminders from '../containers/appUserReminders';
import ActionPlanScreen from '../features/ActionPlan';
import AnswerReminder from '../containers/AnswerReminder';
import GroupsScreen from '../containers/Groups';
import UsersScreen from '../containers/Users';
import EditUserScreen from '../containers/EditUser';
import EvalutedsScreen from '../containers/Evaluateds';
import EditEvaluatedScreen from '../containers/EditEvaluated';
import ScheduleScreen from '../containers/Schedule/index';
import CreateReminderScreen from '../containers/CreateReminder';
import EditCompanyScreen from '../containers/EditCompany';
import DigitalContentsScreen from '../containers/DigitalContents';
import PublicAnswerScreen from '../containers/PublicAnswer';
import FormsScreen from '../containers/Forms';
import FormConstructorScreen from '../containers/FormConstructor';
import RoutinesScreen from '../containers/Routines';
import CreateRoutineScreen from '../containers/CreateRoutine';
import LoginScreen from '../containers/Login';
import withLoginAuth from '../components/withLoginAuth';
import CategoriesScreen from '../containers/Categories';
import PowerBI from 'src/containers/PowerBI';

const protectRoute = (Component) => withLoginAuth(Component);

const routes = {
  unprotected: [
    { path: '/login', component: LoginScreen, exact: true },
    { path: '/reset/:token', component: LoginScreen, exact: true },
    { path: '/forms/public/:id', component: PublicAnswerScreen, exact: true },
  ],
  protected: [
    { path: '/dashboard', component: protectRoute(HomeDashboard), exact: true },
    { path: '/app_users/:app_user_id/answer/:id', component: protectRoute(AnswerReminder), exact: true },
    { path: '/app_user/reminders', component: protectRoute(AppUserReminders), exact: true },
    { path: '/app_user/schedule/new', component: protectRoute(CreateReminderScreen), exact: true },
    { path: '/reports/reminders', component: protectRoute(Reports), exact: true },
    { path: '/action-plan', component: protectRoute(ActionPlanScreen), exact: true },
    { path: '/admin/groups', component: protectRoute(GroupsScreen), exact: true },
    { path: '/admin/users', component: protectRoute(UsersScreen), exact: true },
    { path: '/admin/users/new', component: protectRoute(EditUserScreen), exact: true },
    { path: '/admin/users/edit', component: protectRoute(EditUserScreen), exact: true },
    { path: '/admin/evaluateds', component: protectRoute(EvalutedsScreen), exact: true },
    { path: '/admin/evaluateds/new', component: protectRoute(EditEvaluatedScreen), exact: true },
    { path: '/admin/evaluateds/edit', component: protectRoute(EditEvaluatedScreen), exact: true },
    { path: '/admin/schedule', component: protectRoute(ScheduleScreen), exact: true },
    { path: '/admin/schedule/new', component: protectRoute(CreateReminderScreen), exact: true },
    { path: '/admin/schedule/edit', component: protectRoute(CreateReminderScreen), exact: true },
    { path: '/admin/company/edit', component: protectRoute(EditCompanyScreen), exact: true },
    { path: '/admin/contents', component: protectRoute(DigitalContentsScreen), exact: true },
    { path: '/admin/categories', component: protectRoute(CategoriesScreen), exact: true },
    { path: '/power-bi', component: protectRoute(PowerBI), exact: true },
  ],
  roleSpecific: {
    master: [
      { path: '/forms', component: protectRoute(FormsScreen), exact: true },
      { path: '/forms/new', component: protectRoute(FormConstructorScreen), exact: true },
      { path: '/forms/:id', component: protectRoute(FormConstructorScreen), exact: true },
      { path: '/routines', component: protectRoute(RoutinesScreen), exact: true },
      { path: '/routines/new', component: protectRoute(CreateRoutineScreen), exact: true },
      { path: '/routines/edit', component: protectRoute(CreateRoutineScreen), exact: true },
      { path: '/dashboard/quality', component: protectRoute(QualityDashboard), exact: true },
    ],
    sub_admin: [
      { path: '/dashboard/quality', component: protectRoute(QualityDashboard), exact: true },
    ],
  },
};

export default routes;
